import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
export class ConfirmDialogInterface {
  title: any;
  subtitle?: any;
  descriptionFirst?: any;
  descriptionSecond?: any;
  onlyOkButton?: boolean;
  showSubtitle?: boolean;
}
@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  showSubtitle: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogInterface
  ) { }

  ngOnInit(): void {
    this.showSubtitle = this.data.showSubtitle != undefined ? this.data.showSubtitle : this.showSubtitle;
  }
}
